import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import {
  logOutAction,
  onLoadAction,
  showAuthAction,
} from 'src/store/client/actions';
import { getIsLoggedIn } from 'src/store/client/selectors';
import { getIsWhitelabel } from 'src/store/view/selectors';
import { initAppAction } from 'src/store/view/actions';
import { setIsHiddenHeaderBanner } from 'src/store/headerBanner/slice';
import Layout from './Layout';

const mapStateToProps = (state) => ({
  isLoggedIn: getIsLoggedIn(state),
  isWhiteLabel: getIsWhitelabel(state),
});

const mapDispatchToProps = {
  initApp: initAppAction,
  onLoad: onLoadAction,
  onLogOut: logOutAction,
  onShowAuthPopup: showAuthAction,
  onHideHeaderBanner: setIsHiddenHeaderBanner,
};

export const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(Layout);
